// extracted by mini-css-extract-plugin
export default {"ourClientsPage":"our-clients-page_ourClientsPage__GbPfk","title":"our-clients-page_title__QppoK","block":"our-clients-page_block__tarsO"};